import React from 'react';
import { FeatureGate } from './FeatureGate';

/** Pages only for people with the accountTeams flag; others go home. */
export const TeamsFeature: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <FeatureGate flag="accountTeams">{children}</FeatureGate>;
